import {React, useState, forwardRef} from 'react';

import styles from './messagedialog.module.css';
import constants from '../../../constants.js'

import { useApiProvider } from '../../../providers/ApiProvider.js';

const MessageDialog = () => {

  const { dialogRef, setDialog, closeDialog, isLoading, setIsLoading, dialogTitle, dialogCode, dialogMessage, isError} = useApiProvider();

  return (
    <dialog 
        ref={dialogRef} 
        className={styles.Dialog} 
        style={{borderTop: `2px solid ${isError ? constants.colors.cplRed : constants.colors.cplGreen}`}}>

      <div className={styles.Header}>
        <img className={styles.Close} onClick={closeDialog} src='/icons/close-white.svg'></img><br/>
      </div>
      
      <div className={styles.Body}>
        <div className={styles.Title}>{"Return code: " + dialogCode}</div>
        <div className={styles.Text}>{dialogTitle}</div>
        <div style={{paddingLeft: '5px'}} className={styles.Text}>{dialogMessage ? '"' + dialogMessage + '"' : ""}</div>
      </div>
    </dialog>
  )
}

export default MessageDialog;

